import React, { useState } from "react";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import classes from "./UnsortedStep.module.css";
import { Analytics } from "../../constant/imagePath";
import PropTypes from "prop-types";
import { ReactSVG } from "react-svg";

export const UnsortedStep = ({ data }) => {
  return (
    <div className={classes.stepCard}>
      <p
        style={{
          ...Fonts.p1,
          color: Colors.neutralShadesOfNero,
        }}
        className={classes.stepTitle}
      >
        Step {data?.stepNo}
      </p>
      <div className={`${[classes.imgBox].join(" ")}`}>
        <ReactSVG
          src={data?.icon}
          beforeInjection={(svg) => {
            svg.classList.add(`${[classes.img].join(" ")}`);
          }}
        />
      </div>
      <h5 style={{ ...Fonts.h5, color: Colors.neutralShadesOfNero }}>
        {data?.title}
      </h5>
      <p
        className={classes.tagline}
        style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}
      >
        {data?.tagline}
      </p>
    </div>
  );
};

UnsortedStep.propTypes = {
  data: PropTypes.object,
};

UnsortedStep.defaultProps = {
  data: {
    stepNo: 1,
    icon: Analytics,
    title: "Let us know about your training goals",
    tagline: "You can browse through all coach profiles and sort the results.",
  },
};
